import {
  paidSEM,
  paidSEMNumber,
  dtdDirectNumber,
  defaultPhoneNumber,
} from '../../constants/phoneSalesBannerConstants'
import { flyGaLogic } from '../flyGaLogic'

const showPhoneSalesBanner = (isWLPartner = false, phoneBookInfo) => {
  if (phoneBookInfo?.phoneNumber && !isWLPartner) {
    flyGaLogic.fireGtm(
      'send',
      'event',
      'MFLY-Listings',
      'Phone Sales Banner',
      'Shown to User'
    )
    return true
  }
  return false
}

const getPhoneNumber = (isMobileDevice, searchRefId) => {
  if (paidSEM.indexOf(searchRefId) > -1) {
    return isMobileDevice ? paidSEMNumber.mobile : paidSEMNumber.desktop
  }

  if (searchRefId === 'DTDIRECT') {
    return isMobileDevice ? dtdDirectNumber.mobile : dtdDirectNumber.desktop
  }

  return isMobileDevice ? defaultPhoneNumber.mobile : defaultPhoneNumber.desktop
}

const onPhoneNumberClick = () => {
  flyGaLogic.fireGtm(
    'send',
    'event',
    'MFLY-Listings',
    'Phone Sales Banner',
    'User clicks phone number'
  )
}

export { showPhoneSalesBanner, getPhoneNumber, onPhoneNumberClick }
